export const Balance = ({ width = '30', height = '31' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25 21.75V13H8.75V21.75H6.25ZM13.75 21.75V13H16.25V21.75H13.75ZM2.5 26.75V24.25H27.5V26.75H2.5ZM21.25 21.75V13H23.75V21.75H21.25ZM2.5 10.5V8L15 1.75L27.5 8V10.5H2.5Z"
        fill="white"
      />
    </svg>
  );
};
